module.exports = {
  ORANGE: `#F39E05`,
  RED: `#F4340D`,
  SKYBLUE: `#3952A2`,
  DARKBLUE: `#03158B`,
  NAVYBLUE: `#000840`,
  GREEN: `#25443e`,
}
